<template>
  <section v-if="totalPages > 1">
    <div class="flex items-center justify-center text-sm space-x-2">
      <button
        type="button"
        @click="pageChange(currentPage - 1)"
        :disabled="currentPage <= 1"
        :class="{ 'text-gray-light': currentPage <= 1 }"
      >
        <span class="sr-only">Previous</span>
        <!-- Heroicon name: solid/chevron-left -->
        <svg
          class="h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
            clip-rule="evenodd"
          />
        </svg>
      </button>

      <div v-for="number in pageNumbersToShow" :key="number">
        <button
          type="button"
          v-if="number !== '...'"
          class="h-6 w-6 rounded-full"
          :class="{ 'bg-green-light text-white': currentPage == number }"
          @click="pageChange(number)"
        >
          {{ number }}
        </button>
        <span v-else class="p-1 rounded-full">{{ number }}</span>
      </div>
      <button
        type="button"
        @click="pageChange(currentPage + 1)"
        :disabled="currentPage >= totalPages"
        :class="{ 'text-gray-light': currentPage >= totalPages }"
      >
        <span class="sr-only">Next</span>
        <!-- Heroicon name: solid/chevron-right -->
        <svg
          class="h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    handlePageChange: Function,
    currentPage: Number,
    totalPages: Number,
  },
  data() {
    return {
      threashold: 6,
      pageNumbersToShow: [],
    };
  },
  methods: {
    pageChange(currentPage) {
      this.handlePageChange(currentPage);
    },
    setPageNumbersToShow() {
      const arr = [];
      let prev = true;
      let after = true;
      if (this.totalPages > this.threashold) {
        const valuesArray = [
          1,
          2,
          this.currentPage - 1,
          this.currentPage,
          this.currentPage + 1,
          this.totalPages - 1,
          this.totalPages,
        ];
        for (let i = 1; i <= this.totalPages; i++) {
          if (valuesArray.includes(i)) {
            arr.push(i);
          } else {
            if (i < this.currentPage && prev) {
              arr.push("...");
              prev = false;
            } else if (i > this.currentPage && after) {
              arr.push("...");
              after = false;
            }
          }
        }
      } else {
        for (let i = 1; i <= this.totalPages; i++) {
          arr.push(i);
        }
      }
      this.pageNumbersToShow = arr;
    },
  },
  watch: {
    currentPage: function () {
      this.setPageNumbersToShow();
    },
    totalPages () {
      this.setPageNumbersToShow();
    }
  },
  created() {
    this.setPageNumbersToShow();
  },
};
</script>